import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

const UserSelect = ({ value, onChange, placeholder = "Select Owner", className = "", disabled = false }) => {
  const { data: users, isLoading } = useQuery({
    queryKey: ['users'],
    queryFn: api.getUsers,
  });

  if (isLoading) {
    return (
      <select disabled className={`w-full px-3 py-2 border border-slate-200 rounded-lg bg-slate-50 animate-pulse ${className}`}>
        <option>Loading users...</option>
      </select>
    );
  }

  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value ? parseInt(e.target.value) : null)}
      disabled={disabled}
      className={`form-select ${className} ${disabled ? 'opacity-80 cursor-not-allowed' : ''}`}
      style={{
        backgroundColor: 'var(--bg-base)',
        color: 'var(--text-primary)',
        borderColor: 'var(--border)'
      }}
    >
      <option value="">{placeholder}</option>
      {users?.map((user) => (
        <option key={user.id} value={user.id}>
          {user.full_name} ({user.role})
        </option>
      ))}
    </select>
  );
};

export default UserSelect;
